import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { ModalService } from '../../services/modal.service';
import { Facility } from '../../models/facility.model';

function nonEmptyTrimmed(control: AbstractControl): ValidationErrors | null {
  const value = (control.value ?? '') as string;
  return value.trim().length > 0 ? null : { required: true };
}

@Component({
  selector: 'app-facility-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './facility-form.html',
  styleUrl: './facility-form.css',
})
export class FacilityFormComponent implements OnInit {
  form!: FormGroup;

  private _facility: Partial<Facility> = {};

  constructor(
    private fb: FormBuilder,
    private modalService: ModalService,
  ) {}

  @Input()
  set facility(value: Partial<Facility> | undefined) {
    this._facility = value ?? {};

    if (this.form) {
      this.form.patchValue(
        { name: this._facility.name ?? '' },
        { emitEvent: false },
      );
    }
  }

  get facility(): Partial<Facility> {
    return this._facility;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      name: [this._facility.name ?? '', [Validators.required, nonEmptyTrimmed]],
    });
  }

  isInvalid(controlName: string): boolean {
    const c = this.form.get(controlName);
    return !!c && c.invalid && (c.touched || c.dirty);
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const name = (this.form.value.name as string).trim();
    this.modalService.close({ name });
  }

  onCancel(): void {
    this.modalService.close();
  }
}
